// "Mark Filmed" held on the frontend (OUT-4; docs/OUTPUT-C5-v1.md §2 and §4, rulings A, I, K). A move credits Filmed when
// it leaves a pre-Filmed status for Filmed or anything later (ruling M: a jump past Filmed credits it too). Such a move
// waits for a producer on the card. A Riff card's minutes no longer hold it (HF-FIX-RIFF-1): marked filmed without them,
// its Filmed credit waits as pending until they are set. The API records the move either way (it defaults the producer,
// ruling K); this mirrors the held Approve in Qual (OUT-2.1). No imports, so tests/filmedHold.test.mjs runs it in node
// as it is.

export const NEEDS_PRODUCER = 'Set the producer before marking filmed';
// For a viewer who cannot set the producer themselves: says who can.
export const NEEDS_PRODUCER_ASK = 'Needs a producer, which an admin, producer, power user or manager sets';

const PRE_FILMED = ['Scripted', 'Filming', 'Incomplete'];
const FILMED_ON = ['Filmed', 'Editing', 'Qual', 'Approved', 'Posted'];

// Who sets a card's producer and a Riff card's minutes (the API's gate, routes/liveProduction.js).
export const PRODUCER_ROLES = ['Admin', 'Producer', 'Power User', 'Manager'];
export const canSetProducer = user => !user?.isExternal && (user?.roles || []).some(r => PRODUCER_ROLES.includes(r));

export const creditsFilmed = (from, to) => PRE_FILMED.includes(from) && FILMED_ON.includes(to);
export const isRiff = card => !!card && !card.scriptId && !card.script?.id;
export const hasProducer = card => !!(card?.producerId || card?.producer?.id);

// The sentence that holds moving `card` to `to`, or null when the move may go ahead. With `user`, a viewer who cannot
// set the producer is told who can.
export function filmedHold(card, to, user) {
  if (!card || !creditsFilmed(card.status, to) || hasProducer(card)) return null;
  return user && !canSetProducer(user) ? NEEDS_PRODUCER_ASK : NEEDS_PRODUCER;
}

// What a card's Save sends for the producer and a Riff card's minutes (form: the page's strings; '' = none). Each goes
// only when it changed: an explicit producerId ends the "defaulted" mark (ruling K), and both are refused (403) for roles
// outside the gate, so an unchanged value never rides along with someone else's save. parse: the minutes parser
// (lib/runtimeMinutes parseMinutes). Returns { payload } or { error }.
export function cardChanges(record, form, parse) {
  const payload = {};
  if ((form.producerId || '') !== (record.producerId || '')) payload.producerId = form.producerId || null;
  if (isRiff(record)) {
    const was = record.runtimeMinutes == null ? '' : String(record.runtimeMinutes);
    if (String(form.runtimeMinutes ?? '').trim() !== was) {
      const m = parse(form.runtimeMinutes);
      if (m.error) return { error: m.error };
      if (m.value !== (record.runtimeMinutes ?? null)) payload.runtimeMinutes = m.value;
    }
  }
  return { payload };
}

// Confirm a defaulted producer: the same person, sent explicitly (ruling K). null when there is nothing to confirm.
export const confirmPayload = card => (card?.producerDefaulted && card.producerId ? { producerId: card.producerId } : null);
